import { Component } from '@angular/core';
import { Observable } from 'rxjs';
import {
  DealFacade,
  DealInformation,
  DealUserRole,
  DealVersionSelector
} from '@ipreo/muni-shared';
import { filter, map, mergeMap, startWith } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { PanelOption } from '@ipreo/ngx-sprinkles';

@Component({
  selector: 'muni-gameday-version-selector',
  templateUrl: './version-selector.template.html',
  styleUrls: ['./version-selector.styles.scss'],
  standalone: false,
})
export class VersionSelectorComponent {
  constructor(
    private readonly route: ActivatedRoute,
    private readonly dealFacade: DealFacade
  ) {}
  private readonly dealInformation$: Observable<DealInformation> = this.route.params.pipe(
    mergeMap(() =>
      this.dealFacade.dealState$.pipe(filter((dealInfo) => dealInfo.loaded))
    )
  );
  public readonly selectedDealVersion$: Observable<DealVersionSelector> = this.dealInformation$.pipe(
    map((dealInfo) => dealInfo.selectedVersion)
  );

  public readonly isVersionsChangeAllowed$ = this.dealInformation$.pipe(
    map(
      (res) => res.userRole === DealUserRole.bookrunner && res.hasWorkingVersion
    )
  );

  public readonly versionSelectionItems$: Observable<
    PanelOption[]
  > = this.dealInformation$.pipe(
    map((dealInfo) => {
      const items = [
        {
          id: DealVersionSelector.published,
          text: 'Published Version',
          disabled: !dealInfo.availableVersions.includes(
            DealVersionSelector.published
          ),
          description:
            'Displays only the data that has been released, either via a wire or by the shared data options'
        }
      ];

      if (dealInfo.hasWorkingVersion) {
        items.splice(1, 0, {
          id: DealVersionSelector.working,
          text: 'Working Version',
          disabled: !dealInfo.availableVersions.includes(
            DealVersionSelector.working
          ),
          description:
            'Displays the current state of the deal in Bookrunning, regardless of whether it has been released'
        });
      }

      return items;
    }),
    startWith([])
  );

  public setDealVersion(dealVersion: DealVersionSelector) {
    this.dealFacade.setDealVersion(dealVersion);
  }
}
